import React, { useEffect, useRef, useState } from "react";

const ViewTicketModal = ({ title, tickets = [], onClose , selectedTicket }) => {
  console.log("tickets given " , tickets , selectedTicket)
  // State for image modal
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [imageUrl, setImageUrl] = useState("");

  // Close modal on outside click
    const modalRef = useRef(null);
  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    const handleEscape = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [onClose]);


  const sortedTickets = tickets
  .filter(ticket => ticket.id === selectedTicket || ticket.reference === selectedTicket) // Filter by selectedTicket or Reference
  .sort((a, b) => new Date(b.updated) - new Date(a.updated)); // Sort by `updated` in descending order


  // Open image modal
  const handleOpenImageModal = (url) => {
    setImageUrl(url);
    setImageModalOpen(true);
  };

  // Close image modal
  const handleCloseImageModal = () => {
    setImageModalOpen(false);
    setImageUrl("");
  };

  return (
   
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 p-3 sm:p-4">
    {/* Modal Wrapper */}
      <div
        ref={modalRef}
        className="bg-white rounded-lg shadow-lg w-full max-w-4xl max-h-[90vh] overflow-hidden flex flex-col"
      >
        {/* Modal Header */}
        <div className="flex-none flex justify-between items-start gap-3 border-b px-4 py-4 sm:px-6 bg-gray-100">
          <h2 className="text-xl sm:text-2xl font-semibold">{title}</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 text-2xl"
          >
            &times;
          </button>
        </div>

        {/* Modal Content - Scrollable */}
        <div className="flex-1 p-4 sm:p-6 overflow-y-auto min-h-0 space-y-6">
          {sortedTickets.length > 0 ? (
            sortedTickets.map((ticket) => (
              <div
                key={ticket.id}
                className="p-4 bg-white rounded-md shadow border border-gray-200"
              >
                {/* First Row - Metadata */}
                <div className="mb-4 grid gap-2 sm:grid-cols-2">
                  <p className="text-gray-800">
                    <strong>Initiator:</strong> {ticket.Initiator || "N/A"}
                  </p>
                  <p className="text-gray-800">
                    <strong>Support Member:</strong> {ticket.SupportMember || "N/A"}
                  </p>
                  <p className="text-gray-800">
                    <strong>Created At:</strong>{" "}
                    {new Date(ticket.created).toLocaleString() || "N/A"}
                  </p>
                  <p className="text-gray-800">
                    <strong>Updated At:</strong>{" "}
                    {new Date(ticket.updated).toLocaleString() || "N/A"}
                  </p>
                </div>

                {/* Second Row - Communication */}
                <div
                  className="text-gray-700 border-t pt-4"
                  dangerouslySetInnerHTML={{
                    __html: ticket.Communication || "<p>No communication available.</p>",
                  }}
                ></div>

                {/* Third Row - Attachment */}
                <div className="border-t pt-4 mt-4">
                  <p className="text-gray-800 flex items-center space-x-2">
                    <strong>Attachment:</strong>{" "}
                    {ticket.Screenshot ? (
                      <>
                        <button
                          onClick={() => handleOpenImageModal(ticket.Screenshot)}
                          className="hover:text-blue-700 underline"
                        >
                          View Screenshot
                        </button>
                        <span
                          className="cursor-pointer text-blue-500 hover:text-blue-700"
                          onClick={() => handleOpenImageModal(ticket.Screenshot)}
                        >
                          👁️
                        </span>
                      </>
                    ) : (
                      <span className="text-gray-400">No attachment available</span>
                    )}
                  </p>
                </div>
              </div>
            ))
          ) : (
            <p className="text-center text-gray-500">No tickets available.</p>
          )}

          {/* Padding at the bottom */}
          <div className="h-10" />
        </div>

        {/* Modal Footer */}
        <div className="flex-none flex justify-end px-4 py-4 sm:px-6 border-t bg-gray-100">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
          >
            Close
          </button>
        </div>
      </div>

      {/* Image Modal */}
      {imageModalOpen && (
            <div 
              className="fixed inset-0 z-[60] flex items-center justify-center bg-black bg-opacity-75 p-4"
              onClick={handleCloseImageModal} // Close modal on any click in the overlay
            >
              <div className="relative max-w-4xl max-h-full">
                <img
                  src={imageUrl}
                  alt="Screenshot"
                  className="max-w-full max-h-[85vh] rounded-lg"
                  onClick={(e) => e.stopPropagation()} // Prevent closing when clicking the image itself
                />
              </div>
            </div>
          )}
    </div>
  );
};

export default ViewTicketModal;
